// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import * as Allocation from '@digitalasset/cn-allocation-api-ts-client';
import React, { useContext } from 'react';

export const CNAllocationApiContext = React.createContext<Allocation.DefaultApi | undefined>(
  undefined,
);

export const useCNAllocationApiClient: () => Allocation.DefaultApi = () => {
  const data = useContext<Allocation.DefaultApi | undefined>(CNAllocationApiContext);
  if (!data) {
    throw new Error('CNAllocation client not initialized');
  }
  return data;
};
